<template>
    <div>
        <!--1-->
        <div v-if="showModel==='modelBaseinfo'">
            <van-cell-group title="个人基本信息">
                <van-cell v-for="(item, index) in baseinfoList"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
                <van-cell
                    v-if = "zjly == '0'"
                    title="可用余额"
                    :value="kyye"
                />
                <van-cell title="提前还款方式" is-link @click="doShowArrangeMode" :value="modeSelected" class="van-require-patch" />
                <van-popup v-model="showArrangeMode" position="bottom">
                  <van-picker v-if="showArrangeMode"
                              :columns="mode.text"
                              show-toolbar
                              title="提前还款方式"
                              @cancel="onCancelMode"
                              @confirm="onConfirmMode"
                  >
                  </van-picker>
                </van-popup>
                <van-field
                    v-model="tqje"
                    type="number"
                    required
                    clearable
                    label="申请还款额"
                    placeholder="请输入申请还款额"
                    @input="checkTqje"
                    input-align="right"
                    max-length="10"
                    :disabled="mode.val[mode.text.indexOf(modeSelected)] === '01'"
                />
            </van-cell-group>
<!--            <span class="blank"></span>
            <van-cell-group>
                <van-cell v-for="(item, index) in baseinfoList2"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
            </van-cell-group>
            <span class="blank"></span>
            <van-cell-group>
                <van-cell
                          :title="tqhk.title"
                          :value="tqhk.info"
                />
            </van-cell-group>-->

            <van-button type="default" size="normal" color="#518ede" @click="showNewResult" :square="true" :block="true">下一步</van-button>
        </div>

        <!--2-->
<!--        <div v-if="showModel==='modelComputed'">
            <van-cell-group title="公积金提前还款试算">
                <van-cell
                          title="证件号码"
                          :value="zjhm"
                />
                <van-cell
                          title="借款合同编号"
                          :value="loanAccountNumber"
                />
                <van-cell
                          title="可用余额"
                          :value="kyye"
                />
                <van-field
                        v-model="tqje"
                        type="number"
                        required
                        clearable
                        label="提取金额"
                        placeholder="请输入提取金额"
                        @input="checkTqje"
                        input-align="right"
                        max-length="10"
                        :disabled="mode.val[mode.text.indexOf(modeSelected)] === '01'"
                />
                <van-cell title="调整方式" is-link @click="doShowArrangeMode" :value="modeSelected" class="van-require-patch" />
                <van-popup v-model="showArrangeMode" position="bottom">
                    <van-picker v-if="showArrangeMode"
                            :columns="mode.text"
                            show-toolbar
                            title="调整方式"
                            @cancel="onCancelMode"
                            @confirm="onConfirmMode"
                    >
                    </van-picker>
                </van-popup>
            </van-cell-group>

            <div class="btn-wrap">
                <van-button type="default" size="normal" :square="true" :block="true" color="#666666" @click="showBaseinfo">上一步</van-button>
                <van-button type="default" size="normal" :square="true" :block="true" color="#518ede" @click="showNewResult">下一步</van-button>
            </div>
        </div>-->

        <!--3-->
        <div v-if="showModel==='modelNewresult'" class="model-newresult">
<!--            <van-cell-group title="公积金提前还款试算">
                <van-cell v-for="(item, index) in resultArr"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
            </van-cell-group>-->
            <van-cell-group title="业务办理身份认证">
                <van-cell v-for="(item, index) in resultArr"
                          :key="index"
                          :title="item.title"
                          :value="item.info"
                />
                <van-cell title="中心预留手机号" :value="tel" />
                <van-field
                        v-model="msgCode"
                        type="number"
                        center
                        clearable
                        label="短信验证码"
                        placeholder="请输入短信验证码"
                        class="van-require-patch"
                        input-align="right"
                        maxlength="6"
                >
                    <van-button v-if="!isSend" slot="button" size="small" type="primary" @click="getMsgcode">发送验证码</van-button>
                    <van-button v-else slot="button" size="small" :disabled="true" color="#666666">重新发送{{countdown}}秒</van-button>
                </van-field>
                <!-- <van-field
                        v-model="pwd"
                        input-align="right"
                        type="password"
                        required
                        clearable
                        label="个人密码"
                        placeholder="请输入个人公积金密码"
                        maxlength="16"
                /> -->
            </van-cell-group>
            <div class="btn-wrap">
                <van-button type="default" size="normal" :square="true" :block="true" color="#666666" @click="showCompute">上一步</van-button>
                <van-button type="default" size="normal" :square="true" :block="true" color="#518ede" @click="doVerifyFace">提交</van-button>
            </div>
        </div>

    </div>
</template>

<script>
    import {Cell, CellGroup, Button, Field, Picker, Popup, DatetimePicker} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';
    import 'vant/lib/button/style';
    import 'vant/lib/field/style';
    import 'vant/lib/picker/style';
    import 'vant/lib/popup/style';
    import 'vant/lib/datetime-picker/style';
    import uuidv1 from 'uuid/v1';

    Date.prototype.Format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        "S": this.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
    export default {
        name: 'advanceRepayment',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell,
            vanButton: Button,
            vanField: Field,
            vanPicker: Picker,
            vanPopup: Popup,
            vanDatetimePicker: DatetimePicker
        },
        mounted() {

        },
        data(){
            return {
                gjjInfoList:[],
                zjhm: '',
                loanInfoList: [],
                loanAccountNumber: '',
                showModel:'',
                datalist: [], // 贷款基本信息
                baseinfo: [], // 提前还款检查接口
                baseinfoList: [],
                baseinfoList2: [],
                tqhk: {
                    title: '',
                    info: ''
                },
                repayComputedList: [],
                tqje: '',
                showArrangeMode: false,
                mode: {
                    text: ['期数不变，月还金额减少', '月还金额不变，期数缩短', '全部还清'],
                    val: ['02', '03', '01']
                },
                modeSelected: '请选择...',
                resultArr: [],
                pwd: '',
                tel: '',
                msgCode: '', //短信验证码
                countdown: 60,
                isSend: false,
                hqzq: '',
                kyye: '',
	              zjly: '',
                grzh:'',
            }
        },
        created(){
            this.grzh = this.$store.state.accountNumber.accountNumber;
            this.zjhm = this.$store.state.zwUserInfo.idCard || this.$store.state.btUserInfo.idCard;
            this.tel = this.$store.state.zwUserInfo.tel || this.$store.state.btUserInfo.tel;
            /*this.loanAccountNumber = this.$route.query.account;*/
          // 2023年10月13日15:23:15
	          if(this.$route.query.hasOwnProperty('zjly')) {
              this.zjly = this.$route.query.zjly;
            }
			      console.log('提前偿还公贷页面的 zjly ->', this.zjly);
            this.getJkhthList();
        },
        methods: {
            getSignUrl(){
              let self = this;
              sessionStorage.setItem("gjjInfoList",JSON.stringify(self.gjjInfoList));
              sessionStorage.setItem("zjhm",self.zjhm);
              sessionStorage.setItem("loanInfoList",JSON.stringify(self.loanInfoList));
              sessionStorage.setItem("loanAccountNumber",self.loanAccountNumber);
              sessionStorage.setItem("showModel",self.showModel);
              sessionStorage.setItem("datalist",JSON.stringify(self.datalist));
              sessionStorage.setItem("baseinfo",JSON.stringify(self.baseinfo));
              sessionStorage.setItem("baseinfoList",JSON.stringify(self.baseinfoList));
              sessionStorage.setItem("baseinfoList2",JSON.stringify(self.baseinfoList2));
              sessionStorage.setItem("tqhk",JSON.stringify(self.tqhk));
              sessionStorage.setItem("repayComputedList",JSON.stringify(self.repayComputedList));
              sessionStorage.setItem("tqje",self.tqje);
              sessionStorage.setItem("showArrangeMode",self.showArrangeMode); //布尔
              sessionStorage.setItem("modeSelected",self.modeSelected);
              sessionStorage.setItem("resultArr",JSON.stringify(self.resultArr));
              sessionStorage.setItem("pwd",self.pwd);
              sessionStorage.setItem("tel",self.tel);
              sessionStorage.setItem("msgCode",self.msgCode);
              sessionStorage.setItem("countdown",self.countdown);
              sessionStorage.setItem("isSend",self.isSend);//布尔
              sessionStorage.setItem("hqzq",self.hqzq);
              sessionStorage.setItem("kyye",self.kyye);
              sessionStorage.setItem("zjly",self.zjly);
              sessionStorage.setItem("grzh",self.grzh);

              sessionStorage.setItem("jumpType","eleSign");
              // 拼接参数
              let HDDZ = encodeURIComponent(window.location.href);
              let personData = [];
              let zjhm = self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.zjhm;
              let xingming = self.$store.state.btUserInfo.userName || self.name;
              personData.push(xingming +"~" + zjhm + "~" +"01");
              let QZSJ = {
                personData:personData
              }
              console.log("dd" +personData);
              self.$http.post('/miapp/H3003/mpaasgatewayunencrypted', {
                buztype: 5088, //定值
                JKLX:'scan',  //定值
                YWLXDM:'13',
                YWSSJGDM:'000000',  //定值
                YWBLJGDM:'000000',  //定值
                BLQD:'app', //定值
                YWLCJD:'0',//定值
                AJTM:xingming,
                YWRQ:new Date().Format("yyyyMMdd"),
                time:new Date().getTime(),
                YWLSH:uuidv1(),
                SFZH:zjhm,
                DWZH:'',
                GRXM:xingming,
                WJDM:'TQXYCNS',
                pdf_type:'TQXYCNS',
                QZSJ:QZSJ,
                HDDZ:HDDZ,
                ybmapMessage: {}
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  window.location.replace(res.data);
                } else {
                  self.$utils.alert(res.msg);
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            jumpSignAfter(){
              let self = this;
              let jumpType = sessionStorage.getItem("jumpType");
              sessionStorage.setItem("jumpType","");
              if(this.$route.query.iscallback == '1' && jumpType == 'eleSign'){
                //说明从ocr回来的，代表签字过了，直接调用提交接口
                self.gjjInfoList = JSON.parse(sessionStorage.getItem("gjjInfoList"));
                self.zjhm = sessionStorage.getItem("zjhm");
                self.loanInfoList = JSON.parse(sessionStorage.getItem("loanInfoList"));
                self.loanAccountNumber = sessionStorage.getItem("loanAccountNumber");
                self.showModel = sessionStorage.getItem("showModel");
                self.datalist = JSON.parse(sessionStorage.getItem("datalist"));
                self.baseinfo = JSON.parse(sessionStorage.getItem("baseinfo"));
                self.baseinfoList = JSON.parse(sessionStorage.getItem("baseinfoList"));
                self.baseinfoList2 = JSON.parse(sessionStorage.getItem(""));
                self.tqhk = JSON.parse(sessionStorage.getItem("tqhk"));
                self.repayComputedList = JSON.parse(sessionStorage.getItem("repayComputedList"));
                self.tqje = sessionStorage.getItem("tqje");

                if(sessionStorage.getItem("showArrangeMode") === "false"){
                  self.showArrangeMode = false;
                }else if(sessionStorage.getItem("showArrangeMode") === "true"){
                  self.showArrangeMode = true;
                }

                self.modeSelected = sessionStorage.getItem("modeSelected");
                self.resultArr =  JSON.parse(sessionStorage.getItem("resultArr"));
                self.pwd = sessionStorage.getItem("pwd");
                self.tel = sessionStorage.getItem("tel");
                self.msgCode = sessionStorage.getItem("msgCode");
                self.countdown = sessionStorage.getItem("countdown");

                if(sessionStorage.getItem("isSend") === "false"){
                  self.isSend = false;
                }else if(sessionStorage.getItem("isSend") === "true"){
                  self.isSend = true;
                }

                self.hqzq = sessionStorage.getItem("hqzq");
                self.kyye = sessionStorage.getItem("kyye");
                self.zjly = sessionStorage.getItem("zjly");
                self.grzh = sessionStorage.getItem("grzh");

                sessionStorage.setItem("gjjInfoList","");
                sessionStorage.setItem("zjhm","");
                sessionStorage.setItem("loanInfoList","");
                sessionStorage.setItem("loanAccountNumber","");
                sessionStorage.setItem("showModel","");
                sessionStorage.setItem("datalist","");
                sessionStorage.setItem("baseinfo","");
                sessionStorage.setItem("baseinfoList","");
                sessionStorage.setItem("baseinfoList2","");
                sessionStorage.setItem("tqhk","");
                sessionStorage.setItem("repayComputedList","");
                sessionStorage.setItem("tqje","");
                sessionStorage.setItem("showArrangeMode",""); //布尔
                sessionStorage.setItem("modeSelected","");
                sessionStorage.setItem("resultArr","");
                sessionStorage.setItem("pwd","");
                sessionStorage.setItem("tel","");
                sessionStorage.setItem("msgCode","");
                sessionStorage.setItem("countdown","");
                sessionStorage.setItem("isSend","");//布尔
                sessionStorage.setItem("hqzq","");
                sessionStorage.setItem("kyye","");
                sessionStorage.setItem("zjly","");
                sessionStorage.setItem("grzh","");
              }
            },
          //获取贷款合同号信息
            getJkhthList(){
              let self = this;
              self.$http.post('/miapp/A2009/mpaasgatewayunencrypted' , {
                // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                ybmapMessage: {
                  zjhm: self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.zjhm
                }
              }).then(res => {
                self.$utils.loading(false);
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  if(res.result.length > 0){
                    self.loanAccountNumber = res.result[res.result.length - 1].jkhtbh;
                    this.getKyyeInfo();
                  } else {
                    self.$utils.alert('未查询到贷款账户号');
                  }
                } else {
                  self.$utils.alert(res.msg, function(){
                    self.$router.go(-1);
                  });
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            // 2 调用贷款基本信息接口
            getLoanInfo(){
                let self = this;
                // self.$http.post('/miapp/A5104/mpaasgateway', { //政务
                self.$http.post('/miapp/A2003/mpaasgatewayunencrypted', {
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    ybmapMessage: {
                        cxlx: '03',
                        cxlxz: self.loanAccountNumber,
                        zjhm: self.$store.state.btUserInfo.idCard || self.$store.state.zwUserInfo.idCard,
                        jkhth: self.loanAccountNumber
                    }
                }).then(res => {
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                      self.datalist = res.result;
                      let titleObj = ["dkjgmc","swtdkyhmc","jkhth","jkrxm","dkje","dkye","dkqx","dksyqs","dkfkrq","dkjsrq",
                        "yll","hkr","hkzh","yhke","htzt"];
                      this.addBaseInfo(titleObj,res.result);

                      if(self.zjly == '1'){
                        let titleObj = ["kkzh"];
                        this.addBaseInfo(titleObj,res.result);
                      }

                      let titleObj1 = ["hkfs"];
                      this.addBaseInfoFormat(titleObj1,res.result,"3");
                      console.log('贷款信息查询 self.datalist ->', JSON.stringify(res.result));
                      this.getTotalMoney();
                    } else {
                      self.$utils.alert(res.msg);
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            getBaseinfo(){
              let self = this;
              self.$http.post('/miapp/A2001/mpaasgatewayunencrypted' , {
                buztype: 5001,
                usertype: 10,
                ybmapMessage: {
                  cxlx: '03',
                  cxlxz: self.grzh
                }
              }).then(res => {
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  self.gjjInfoList = res.result;

                  let titleObj = ["grzh","dwzh","gjjye","btye"];
                  this.addBaseInfo(titleObj,res.result);
                  console.log("结果");
                  console.log(self.baseinfoList);

                  self.getLoanInfo();
                }else {
                  self.$utils.alert(res.msg);
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            getKyyeInfo(){
              let self = this;
              self.$http.post('/miapp/A5022/mpaasgatewayunencrypted', {
                // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                ybmapMessage: {
                  grzh: self.$store.state.accountNumber.accountNumber,
                  zjhm: self.$store.state.btUserInfo.idCard,
                  coreUserid: self.$store.state.btUserInfo.coreUserid,
                  channel: '11',
                  flag: self.zjly
                }
              }).then(res => {
                res = typeof res === 'string' ? JSON.parse(res) : res;
                if(res.recode === '000000'){
                  self.baseinfo = res.result;
                  self.kyye = this.returnFieldValue(self.baseinfo, 'kyye');
                  console.log("可用余额" +self.kyye);
                  this.getBaseinfo();
                } else {
                  self.$utils.alert(res.msg);
                }
              }).catch(res => {
                self.$utils.loading(false);
                console.log("error", res);
              });
            },
            // 3 获取提前还款总金额
            getTotalMoney(){
                let self = this;
                self.$http.post('/miapp/A5021/mpaasgatewayunencrypted', {
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    ybmapMessage: {
                        hkzh: self.loanAccountNumber,
                        hkrq: String(new Date().getFullYear()) + String(new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1) + String(new Date().getDate() < 10 ? '0'+new Date().getDate() : new Date().getDate()),
                        hklx: '05',
                        tqhkfs: '01',
                        tqhkafter: '0',
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        this.tqhk.title = '提前还款总额';
                        this.tqhk.info = res.hj;
                        self.showModel = 'modelBaseinfo';
                        let jumpType = sessionStorage.getItem("jumpType");
                        if(this.$route.query.iscallback == '1' && jumpType == 'eleSign'){
                          self.jumpSignAfter();
                        }else{
                          if('1' == this.zjly){
                            this.$utils.alert('您好！选择通过银行卡余额提前偿还公积金贷款的，需由代扣银行卡持有人本人操作！提交成功后，我中心将在1个工作日将审核结果以短信方式反馈给您！');
                          }
                        }
                    } else {
                        self.$utils.alert(res.msg);
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },

            // 公积金提前还款试算
            showCompute(){
                this.showModel = 'modelBaseinfo';
            },
            showNewResult(){
                let self = this;
                /*if((Number(this.returnFieldValue(self.baseinfo, 'gjjye')) < Number(this.tqhk.info)) && self.mode.val[self.mode.text.indexOf(self.modeSelected)] === '01'){
                    self.$utils.alert('余额不足，不可以选择全部还清', () => {
                        self.doShowArrangeMode();
                    });
                    return false;
                }*/
                if(self.mode.val[self.mode.text.indexOf(self.modeSelected)] !== '01' && self.mode.val[self.mode.text.indexOf(self.modeSelected)] !== ''){
                    /*if(Number(this.returnFieldValue(self.baseinfo, 'kyye')) - Number(self.tqje) < 100){
                        self.$utils.alert('应公积金业务要求，公积金账户必须至少剩余100.00元');
                        return false;
                    }*/

                  if(Number(self.tqje) < 100){
                    self.$utils.alert('请输入百元以上金额！');
                    return false;
                  }

                  if(Number(self.tqje) % 100 !== 0){
                    self.$utils.alert('请输入百元整数倍金额！');
                    return false;
                  }

                  if(self.zjly == '0' && (Number(self.tqje) > Number(self.kyye))){
                    self.$utils.alert('申请还款额不可超过您的可用金额，请重新输入');
                    return false;
                  }
                }
                if(self.zjly == '0' && self.mode.val[self.mode.text.indexOf(self.modeSelected)] === '01'){
                    if((Number(this.returnFieldValue(self.baseinfo, 'gjjye')) + Number(this.returnFieldValue(self.baseinfo, 'btye'))) < Number(self.tqje)){
                        self.$utils.alert('公积金余额加补贴余额小于还清应还总额，无法全部还清，请重新选择提前还款方式！');
                        return false;
                    }
                }
                console.log(self.datalist);
                console.log(self.returnFieldValue(self.datalist, 'yhke'));
                //页面校验，当选择不是全部还清时，需要提取金额大于一个月的月还款额
                /*if(self.mode.val[self.mode.text.indexOf(self.modeSelected)] !== '01' && Number(self.tqje) <= Number(self.returnFieldValue(self.datalist, 'yhke'))){
                    self.$utils.alert('提取金额大于一个月的月还款额');
                    return false;
                }*/
                if(!this.zjhm){
                    self.$utils.alert('证件号码获取失败');
                    return false;
                }
                if(!this.loanAccountNumber){
                    self.$utils.alert('借款合同号获取失败');
                    return false;
                }
                if(String(this.tqje).trim() === ''){
                    self.$utils.alert('请输入申请还款额');
                    return false;
                }
                if(self.modeSelected === '请选择...'){
                    self.$utils.alert('请选择调整方式');
                    return false;
                }

                let modeSelectedCode = self.mode.val[self.mode.text.indexOf(self.modeSelected)];

                self.$http.post('/miapp/A5023/mpaasgatewayunencrypted', {
                  // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                  ybmapMessage: {
                    zjhm: self.zjhm,
                    jkhtbh: self.loanAccountNumber,
                    tqje: self.tqje,
                    tzfs: modeSelectedCode,
                  }
                }).then(res => {
                  self.$utils.loading(false);
                  res = typeof res === 'string' ? JSON.parse(res) : res;
                  if (res.recode === '000000') {
                    self.resultArr = [];
                    self.resultArr.push({title: '新月还金额', info: res.newyhje});
                    self.resultArr.push({title: '新剩余期数', info: res.newsyqs});
                    self.showModel = 'modelNewresult';
                    self.getSignUrl();
                  } else {
                    self.$utils.alert(res.msg);
                  }
                }).catch(res => {
                  self.$utils.loading(false);
                  console.log("error", res);
                });
            },
            checkTqje(){
                /*if(Number(this.tqje) > Number(this.tqhk.info)){
                    this.$utils.alert('提取金额不能大于提前还款总金额', ()=>{
                        this.tqje = this.tqhk.info;
                    });
                }*/
            },
            doShowArrangeMode(){
                this.showArrangeMode = true;
            },
            onCancelMode(){
                this.showArrangeMode = false;
            },
            onConfirmMode(value, index){
                let self = this;
                this.modeSelected = value;
                console.log('选择提前还款方式->', value);
                if(value === '全部还清'){
                    self.tqje = self.tqhk.info;
                }
                this.showArrangeMode = false;
            },
            showBaseinfo(){
                this.showModel = 'modelBaseinfo';
            },
            showComputed(){
                this.showModel = 'modelComputed';
            },
            doVerifyFace(){
                let self = this;
                //测试用
                self.doSubmit();
                return false;
                //测试用  结束

                if(lightAppJssdk){
                    // 江苏政务刷脸
                    lightAppJssdk.face.face({
                        idnum: self.$store.state.zwUserInfo.idCard,//身份证号
                        name: self.$store.state.zwUserInfo.userName,//真实姓名
                        success:function(data){
                            self.doSubmit();
                        },
                        fail:function(data){
                            self.$utils.alert(data.msg);
                        }
                    });
                } else {
                    // 百通刷脸，待测试
                }
            },
            checkPwd(){
                let self = this;
                self.pwd = self.pwd.replace(/[^0-9]/g,'');
                if(self.pwd.length > 6) {
                    self.pwd = self.pwd.slice(0, 6);
                    self.$utils.alert('个人密码为6位数字');
                    return false;
                }
            },
            // 获取短信验证码
            getMsgcode(){
                let self = this;
                self.$http.post('/miapp/A5009/mpaasgatewayunencrypted', {
                    buztype: 5088,
                    xingming: encodeURI(self.$store.state.btUserInfo.userName) || encodeURI(self.name),
                    ybmapMessage: {
                        sjhm: self.tel,
                        zjhm: self.idCard || this.$store.state.btUserInfo.zjhm,
	                    xingming: self.$store.state.btUserInfo.userName || self.name,
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){
                        let _checkCount = function _checkCount() {
                            //验证码倒计时
                            if (self.countdown === 0) {
                                self.isSend = false;
                                self.countdown = 60;
                                return;
                            } else {
                                self.isSend = true;
                                self.countdown--;
                            }
                            setTimeout(function () {
                                _checkCount();
                            }, 1000);
                        };
                        _checkCount();
                    } else {
                        self.$utils.alert(res.msg);
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            doSubmit(){
                let self = this;
                // if(self.pwd.length < 8 || self.pwd.length > 16){
                //     self.$utils.alert('个人密码为8-16位之间');
                //     return false;
                // }
                if(self.msgCode === ''){
                    self.$utils.alert('请输入短信验证码');
                    return false;
                }

                //提取金额的控制，当提取金额tqje小于补贴余额btye时，优先提取补贴余额(je=0,btje=tqje)；
                // 当提取金额大于补贴余额时，先提取完补贴余额btye(btje=btye),然后剩下的从公积金余额里取（je=tqje-btye）
                let _tqje = 0,
                    _je = 0,
                    _btye = self.returnFieldValue(self.baseinfo, 'btye'),
                    _btje = 0;

                if(Number(self.tqje) <= Number(_btye)){
                    _je = 0;
                    _btje = Number(self.tqje);
                }
                if(Number(self.tqje) > Number(_btye)){
                    _btje = Number(_btye);
                    _je = (self.tqje*1000 - _btye*1000)/1000;
                }
                /*if(Number(self.tqje) === Number(self.btje)){
                    _je = 0;
                }*/

                if(self.mode.val[self.mode.text.indexOf(self.modeSelected)] === '01') self.hqzq = 'on';

                let _ybmapMessage = {
                    coreUserid: self.$store.state.btUserInfo.coreUserid,
                    grzh: self.$store.state.accountNumber.accountNumber,
                    dwzh: self.$store.state.btUserInfo.dwzh,
                    hkzh: self.loanAccountNumber,
                    cllx: '6A',
                    qkfs: '04',
                    sprq: new Date().getFullYear() + String(new Date().getMonth()+1 < 10 ? '0'+(new Date().getMonth()+1) : new Date().getMonth()+1) + String(new Date().getDate() < 10 ? '0'+new Date().getDate() : new Date().getDate()) ,
                    hjny: self.returnFieldValue(self.baseinfo, 'hjny'),
                    zqorgcode: self.returnFieldValue(self.baseinfo, 'zqorgcode'),
                    zqocid: self.returnFieldValue(self.baseinfo, 'zqocid'),
                    hjstatus: self.returnFieldValue(self.baseinfo, 'hjstatus'),

                    gjjye: self.returnFieldValue(self.baseinfo, 'gjjye'),
                    btje: String(_btje),
                    btye: _btye,
                    je: String(_je),

                    hqyhze: self.tqhk.info,
                    tqhkfs: self.mode.val[self.mode.text.indexOf(self.modeSelected)],
                    zzhd: '1',
                    // mima: self.pwd,
                    sjhm: self.$store.state.btUserInfo.tel,

                    hqzq: self.hqzq,
                    yzm: self.msgCode,
                };


                // self.$http.post('/miapp/A5124/mpaasgateway', { // 政务
              if(self.zjly == '0') {
                self.$http.post('/miapp/A5024/mpaasgatewayunencrypted', {
                  // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                  ybmapMessage: _ybmapMessage,
                  money: String(self.tqje)
                }).then(res => {
                  self.$utils.loading(false);
                  res = typeof res === 'string' ? JSON.parse(res) : res;
                  if (res.recode === '000000') {
                    self.$utils.alert('业务办理成功！', function () {
                      // self.routingTo('');
                    });
                    self.doReport();
                  } else {
                    self.$utils.alert(res.msg);
                  }
                }).catch(res => {
                  self.$utils.loading(false);
                  console.log("error", res);
                });
              }else{
                  let hkzh = self.returnFieldValue(self.baseinfoList,"hkzh");//还款账号
                  let xingming = self.returnFieldValue(self.gjjInfoList,"xingming");//还款账号
                  let modeSelectedCode = self.mode.val[self.mode.text.indexOf(self.modeSelected)];//还款方式
                  self.$http.post('/miapp/H2001/mpaasgatewayunencrypted', {
                    // ticket: self.$store.state.zwticket.zwticket ? self.$store.state.zwticket.zwticket : '',
                    ybmapMessage: {
                      coreUserid:self.$store.state.btUserInfo.coreUserid,
                      channel:'11',
                      je:String(self.tqje),
                      tqhkfs:modeSelectedCode,
                      hkzh:hkzh,
                      sjhm:self.$store.state.btUserInfo.tel,
                      grzh:self.$store.state.accountNumber.accountNumber,
                      xingming:xingming,
                      yzm:self.msgCode,
                    },
                    money:String(self.tqje)
                }).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if (res.recode === '000000') {
                      self.$utils.alert('业务办理成功！', function () {
                        // self.routingTo('');
                      });
                      self.doReport();
                    } else {
                      self.$utils.alert(res.msg);
                    }
                  }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                  });
              }
            },
            doReport(){
                let self = this;
                console.log('baitong', self.$store.state.baitong);
                self.$http.post('/miapp/C0001/mpaasgatewayunencrypted', {
                    "accessToken": self.$store.state.baitong.userAccessToken,
                    "openId": self.$store.state.btUserInfo.openId,
                    "idCard": self.$store.state.btUserInfo.idCard,
                    "reportedData": {
                        "serviceId": "转账提前偿还公积金贷款",
                        "ywName": "转账提前偿还公积金贷款",
                        "statusNo": "1",
                        "eventName": "转账提前偿还公积金贷款提交",
                        "orderId": self.$store.state.btUserInfo.idCard + Date.parse(new Date()),
                        "remark": "",
                        "detailInfo": {
                            "APPLICANT_NAME": self.$store.state.btUserInfo.userName,
                            "APPLY_DATE": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                            "ORG_NAME": "南通市住房公积金中心",
                            "process": [
                                {
                                    "END_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                                    "EVENT_NAME": "转账提前偿还公积金贷款",
                                    "START_NOTE": "通过",
                                    "START_TIME": new Date( +new Date() + 8 * 3600 * 1000 ).toJSON().substr(0,19).replace("T"," "),
                                    "START_USER_NAME": "南通市住房公积金中心"
                                }
                            ],
                            "statuNO": "1",
                            "smtApplyFile":[]
                        }
                    }
                }, {loading: false}).then(res => {
                    self.$utils.loading(false);
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000'){

                    } else {
                        self.$utils.alert(res.msg || '业务上报失败');
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    console.log("error", res);
                });
            },
            addBaseInfo(titleObj,result){
              let self = this;
              for(let i = 0;i < titleObj.length;i++){
                for(let j = 0;j < result.length;j++){
                  if(titleObj[i] == result[j].name){
                    self.baseinfoList.push(result[j]);
                  }
                }
              }
            },
            addBaseInfoFormat(titleObj,result,format){
              let self = this;
              for(let i = 0;i < titleObj.length;i++){
                for(let j = 0;j < result.length;j++){
                  if(titleObj[i] == result[j].name && result[j].format == format){
                    self.baseinfoList.push(result[j]);
                  }
                }
              }
            },
            returnFieldValue(data, name){
                return data.filter(function(item, index){
                    if(item.name === name){
                        return item.info;
                    }
                })[0].info;
            },
            returnFieldObj(data, name){
              return data.filter(function(item, index){
                if(item.name === name){
                  return item;
                }
              });
            },
            routingTo(target, query){
                let self = this;
                self.$router.push({
                    path: '/' + target,
                    query: {
                        'openweb': 'paschybrid'
                    }
                });
            }
        }
    }
</script>

<style lang="stylus">
    .van-field__label
        width auto
        text-overflow ellipsis
        padding-right 12px
    .van-require-patch
        position relative
        width 100%
        &:before
            position absolute
            left 18px
            color #ee0a24
            font-size .32rem
            content '*'
    .van-cell-group__title
        color #518ede
        font-weight 400
    .van-cell__value
        flex 2
</style>
<style lang="stylus" scoped>
    .van-cell:not(:last-child)::after
        left 0
    .blank
        height .2rem
        display block
    .btn-wrap
        display flex
    .van-field
        flex-wrap nowrap
    .van-button--normal
        margin .3rem auto .2rem
    .van-cell__value
        word-break break-all
</style>